module.exports = __webpack_public_path__ + "static/img/areaB_09.7618052.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_09.png
// module id = 1270
// module chunks = 1